import { usePreventLeaveDuringUpload } from '@ldt/features/orders/hooks/use_prevent_leave_during_upload';
import { FeedbackPopup, FeedbackType } from 'src/components/feedback_popup';
import { Warning } from 'src/components/icons/warning';

interface PreventLeaveDuringUploadDialogProps {
  orderId: string;
  enabled?: boolean;
}

export const PreventLeaveDuringUploadDialog = ({
  orderId,
  enabled = true,
}: PreventLeaveDuringUploadDialogProps) => {
  const { isNavigationBlocked, confirmLeave, cancelLeave } =
    usePreventLeaveDuringUpload(orderId, enabled);

  return (
    <FeedbackPopup
      data={{
        primaryButtonText: 'STAY',
        secondaryButtonText: 'LEAVE PAGE',
        title: 'Uploads In Progress',
        subtitle:
          'Files are still uploading. If you leave now, your uploads may be interrupted and fail.',
        icon: Warning,
        type: FeedbackType.Warning,
      }}
      isDialogOpen={isNavigationBlocked}
      onPrimaryButtonClick={cancelLeave}
      onSecondaryButtonClick={confirmLeave}
      handleDialogClose={cancelLeave}
      primaryButtonTestId='upload-files-stay-button'
      secondaryButtonTestId='upload-files-leave-page-button'
    />
  );
};
